<div class="component-viewer">
    <div class="row">
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
    <scheduler-skeleton *ngIf="isInitializing"></scheduler-skeleton>
    <div class="simulator-calendars" #schedulerContainer>
        <ejs-schedule #scheduleObj *ngIf="!isInitializing" [timezone]="userDetails?.timeZone" [currentView]="currentView" [(selectedDate)]="selectedDate" [workHours]="workHours"
            [allowDragAndDrop]="true" [allowOverlap]="false" [eventSettings]="eventSettings" height="100%" width="100%"
            [group]="group" [resourceHeaderTemplate]="resourceHeaderTemplate" [startHour]="dayStartHour" [allowSwiping]="false"
            [endHour]="dayEndHour" (dragStop)="onEventDrag($event)" (cellClick)="onCellClick($event)"
            (popupOpen)="onPopupOpen($event)" (eventDoubleClick)="onEventDoubleClick($event)"
            (eventRendered)="onEventRendered($event)" (renderCell)="onRenderCell($event)"
            (resizeStart)="disableResize($event)" (resizeStop)="disableResize($event)">
            <e-resources>
                <e-resource field='SimulatorId' title='Simulator' name='simulators' [allowMultiple]="false"
                    [dataSource]="simulators" textField="simulatorTitle" idField="id" ></e-resource>
            </e-resources>
            <e-views>
                <e-view option='Day'>
                    <ng-template #eventTemplate let-data>
                        <div class="e-appointment-details">
                            <div class="e-subject">{{data.Subject}}</div>
                            <div class="e-time">{{data.StartTime | date: 'shortTime'}} - {{data.EndTime | date: 'shortTime'}}</div>
                            <div class="e-description">{{data.Status.includes('Member') ? 'Member Booking' : ''}}</div>
                        </div>
                    </ng-template>
                </e-view>
                <e-view option='TimelineDay'></e-view>
                <e-view option='Week'></e-view>
            </e-views>
            <e-toolbaritems>
                <e-toolbaritem name="Custom" align="Left">
                    <ng-template #template>
                        <div style="display: flex; align-items: center; gap: 8px; position: relative;">
                            <button ejs-button cssClass="e-flat e-round e-outline" iconCss="e-icons e-chevron-left" [ngClass]="{'primary-color-border': !isPreviousDayDisabled()}"
                                [disabled]="isPreviousDayDisabled()" (click)="changeSelectedDate(-1)" isPrimary="true">
                            </button>

                            <button ejs-dropdownbutton cssClass="e-flat e-caret-hide" width="100%" 
                                [target]="'#calendar-popup'" style="box-shadow: none !important; transform: scale(0.8); width: 8rem;" [content]="selectedDate | date: 'mediumDate'" >
                            </button>
                            <div id="calendar-popup"
                                style="position: absolute; z-index: 1000; background: white; box-shadow: 0 2px 8px rgba(0,0,0,0.2); border-radius: 4px;">
                                <ejs-calendar #calendar [value]="selectedDate" [min]="minDate" [max]="maxDate"
                                    (change)="onDatePickerChange($event)">
                                </ejs-calendar>
                            </div>

                            <button ejs-button cssClass="e-flat e-round e-outline primary-color-border" iconCss="e-icons e-chevron-right"
                                (click)="changeSelectedDate(1)" isPrimary="true">
                            </button>
                        </div>
                    </ng-template>
                </e-toolbaritem>
                <e-toolbaritem type="Separator" align="Left"></e-toolbaritem>
                <e-toolbaritem type="Button" name="Custom" align="Left">
                    <ng-template #template>
                        <button ejs-button cssClass="e-flat e-outline primary-color-border" isPrimary="true" iconCss="e-icons e-plus" (click)="createScheduledBooking()">Scheduled Booking</button>
                    </ng-template>
                </e-toolbaritem>
                <e-toolbaritem type="Button" name="Today" align="Right"></e-toolbaritem>
                <e-toolbaritem type="Separator" align="Right"></e-toolbaritem>
                <e-toolbaritem name="Views" align="Right"></e-toolbaritem>
            </e-toolbaritems>
            <ng-template #quickInfoTemplatesFooter let-data=>
                <ng-container [ngTemplateOutlet]="data.elementType == 'cell' ? cellFooter : eventFooter"
                    [ngTemplateOutletContext]="{data:data}"></ng-container>
            </ng-template>
            <ng-template #cellFooter let-data="data">
                <div class="e-cell-footer">
                    <button ejs-button id="more-details" cssClass="e-flat">More
                        Details</button>
                    <button ejs-button id="add" cssClass="e-flat" [isPrimary]="true"
                        (click)="onCellClick($event)">Add</button>
                </div>
            </ng-template>
            <ng-template #eventFooter let-data="data">
                <div class="e-event-footer">
                    <button ejs-button *ngIf="!isBookingPast(data.EndTime)" id="more-details" cssClass="e-flat"
                        [isPrimary]="true" (click)="onEventEdit(data)">Edit</button>
                    <button ejs-button *ngIf="!isBookingPast(data.EndTime) && data.Status.includes('Scheduled')" id="more-details" cssClass="e-flat"
                        (click)="onEventEdit(data, true)">Modify Schedule</button>
                    <button ejs-button *ngIf="!isBookingPast(data.EndTime)" id="delete" cssClass="e-flat e-warning"
                        (click)="onEventCancel(data)">Cancel</button>
                    <button ejs-button *ngIf="isBookingPast(data.EndTime)" id="delete" cssClass="e-flat e-warning"
                        (click)="onEventCancel(data)">Delete</button>
                </div>
            </ng-template>
        </ejs-schedule>
    </div>
</div>

<ng-template #resourceHeaderTemplate let-data>
    <div style="display: flex; align-items: center; gap: 0px;">
        <mat-icon style="transform: scale(0.8);">sports_golf</mat-icon>
        <span>
            {{ data.resourceData.simulatorTitle }}
        </span>
    </div>
</ng-template>
